// extracted by mini-css-extract-plugin
export default {"phoneDiv":"reset-password_phoneDiv__7tBkV","otpDiv":"reset-password_otpDiv__V8jgL","passwordDiv":"reset-password_passwordDiv__cM2qB","successDiv":"reset-password_successDiv__5G8sC"};